import {
    FETCH_WORKHOURS_CURRENT_WEEK,
    FETCH_WORKHOURS_CURRENT_WEEK_ERROR,
    FETCH_WORKHOURS_CURRENT_WEEK_SUCCESS,
    FETCH_MENU_ITEMS, FETCH_MENU_ITEMS_ERROR, FETCH_MENU_ITEMS_SUCCESS, MainMenuActionTypes
} from '../../actions/menu/MainMenuActions';
import { RouteConfig }  from '../../config/RouteConfig';
import { RequestState } from '../../models/common/RequestState';
import { UserWorkhours } from '../../models/users/User';
import { getTimePeriodFromDate } from '../../models/calendar/Calendar';
import { MenuItem } from '../../models/menu/Menu';

export interface MainMenuState {
    menu: {
        navItems: MenuItem[] | null
        notifications: 0
        workhours: UserWorkhours
        help: null
    }
    request: RequestState
}

const initialState: MainMenuState = {
    menu: {
        navItems: null,
        notifications: 0,
        workhours: {
            period: getTimePeriodFromDate( new Date() ),
            mandatoryWorkhours: 0,
            realWorkhours: 0
        },
        help: null,
    },
    request: {
        error: null,
        isFetching: false,
        lastRequestSuccess: 0
    }
};

export const MainMenuReducer = ( state = initialState, action: MainMenuActionTypes ): MainMenuState => {

    switch( action.type ) {
        case FETCH_WORKHOURS_CURRENT_WEEK:
            return {
                ...state,
                request: {
                    error: null,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_WORKHOURS_CURRENT_WEEK_SUCCESS:

            return {
                ...state,
                menu: {
                    ...state.menu,
                    workhours: action.workhours
                },
                request: {
                    error: null,
                    isFetching: false,
                    lastRequestSuccess: Date.now()
                }
            };
        case FETCH_WORKHOURS_CURRENT_WEEK_ERROR:

            return {
                ...state,
                menu: {
                    ...state.menu,
                    workhours: {
                        ...state.menu.workhours
                    }
                },
                request: {
                    error: action.error,
                    isFetching: false,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_MENU_ITEMS:
            return {
                ...state,
                request: {
                    error: null,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_MENU_ITEMS_SUCCESS:
           // console.log( action );
            return {
                ...state,
                menu: {
                    ...state.menu,
                    navItems: buildMenu( action.menu ),
                },
                request: {
                    ...state.request,
                    isFetching: false,
                    lastRequestSuccess: Date.now()
                }
            };
        case FETCH_MENU_ITEMS_ERROR:
            return {
                menu: {
                    ...state.menu,
                    navItems: null,
                },
                request: {
                    error: action.error,
                    isFetching: false,
                    lastRequestSuccess: 0
                }
            };
        default:
            return state;
    }
};

/**
 * helper function to categorise the views into 1.6 views and 2.0 one page application ( opa ) views
 */
const buildMenu = ( views: MenuItem[] ) => {
    if( views === null ) {
        return null;
    }
    return views.map( view => {
        for( const key in RouteConfig ) {
            if( key in RouteConfig ) {
                if( RouteConfig[ key ].viewIdentifier === view.linkTitle.rawValue ) {
                    return {
                        ...view,
                        ...RouteConfig[key],
                        isOpaLink: true,
                    };
                }
            }
        }
        return {
            ...view,
            isOpaLink: false,
        };
    });


};